import { Tag, Button, Popconfirm, Space } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

export function getWhatsAppChatbotContactColumns({ canEdit, onEdit, onDelete, onToggleChatbot }) {
  return [
    {
      title: 'Phone',
      dataIndex: 'phone_number',
      key: 'phone_number',
      render: (text) => <span className="font-mono text-sm">{text}</span>,
    },
    {
      title: 'Display name',
      dataIndex: 'display_name',
      key: 'display_name',
      render: (text) => text || <span className="text-gray-400">—</span>,
    },
    {
      title: 'Active',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 90,
      render: (v) => <Tag color={v ? 'green' : 'default'}>{v ? 'Yes' : 'No'}</Tag>,
    },
    {
      title: 'Chatbot',
      dataIndex: 'chatbot_enabled',
      key: 'chatbot_enabled',
      width: 100,
      render: (v, record) => (
        canEdit ? (
          <Tag
            color={v ? 'cyan' : 'default'}
            className="cursor-pointer"
            onClick={() => onToggleChatbot(record)}
          >
            {v ? 'Enabled' : 'Disabled'}
          </Tag>
        ) : (
          <Tag color={v ? 'cyan' : 'default'}>{v ? 'Enabled' : 'Disabled'}</Tag>
        )
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 160,
      render: (_, record) => (
        <Space size="small">
          {canEdit && (
            <Button type="default" size="small" icon={<EditOutlined />} onClick={() => onEdit(record)}>
              Edit
            </Button>
          )}
          {canEdit && (
            <Popconfirm
              title="Remove this contact?"
              onConfirm={() => onDelete(record)}
              okText="Delete"
              okButtonProps={{ danger: true }}
            >
              <Button type="text" danger size="small" icon={<DeleteOutlined />}>
                Delete
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];
}

export const ACTIVE_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
];
